<template>
  <div class="about">
    <div class="top_back">
      <DivTop :active='6' />
      <div class="w120 bj_box">
        <span>关于金飞鹰</span>
        <span>金飞鹰倾力打造强大的生态体系和多样化的服务支持，助您无忧。</span>
      </div>
      <div class="bjs">

      </div>
    </div>
    <div class="about_content">
      <div class="w120">
        <div class="core_top">
          <span>金飞鹰公司介绍</span>
          <img src="@/assets/nav.png" alt="">
        </div>
        <div class="cont_imgs">
          <img src="@/assets/about.png" alt="">
        </div>
        <div class="content_txt">
              <p>公司简介</p>
              <span>
              北京金飞鹰科技发展有限公司（www.softykt.cn）创立于2003年，是国内滑雪行业内认可度比较高的管理体系提供商，为19个省和3个自治区的滑雪场、戏雪乐园提供管理体系建设。2019年11月金飞鹰数据显示，使用金飞鹰科技管理系统用户超过200家，占全国份额的三分之一。金飞鹰经过与行业内的管理专家与公司研发人员对滑雪场的运营进行全面的剖析和量化处理方面的探讨，逐步实现了板鞋分离租借、计时点位自由设定、电子码套票、计次卡、自助购买滑雪项目等一系列方便雪场运营人员在电子管理系统中的应用。金飞鹰根据以往的经验，为客户量身打造符合自身特色的产品、管理体系以及团队建设规划。此外，金飞鹰在每个雪季结束后，都会与客户沟通，收集客户提出的需要提升的功能并加以改进，为客户在下一雪季提供更加优质的服务。</span>
              <span>
                北京金飞鹰科技发展有限公司自成立以来，在景区、滑雪场管理等领域取得了多个著作权，这也是金飞鹰取得的巨大成就，主要包括：金飞鹰雪场系统、金飞鹰冰场运营系统、金飞鹰智慧景区管理系统、金飞鹰SkiCSF雪场气象报告系统、金飞鹰体育场馆管理系统、金飞鹰GEYKT雪场门禁管理系统、金飞鹰-OA优创雪场办公系统、金飞鹰SkiLink雪场收费管理系统、金飞鹰雪务通管理系统、金飞鹰极昼滑雪场智能灯光控制系统、金飞鹰威智论滑雪场监控系统。
              </span>
          </div>
      </div>
    </div>
    <div class="about_show">
      <div class="w120">
        <div class="core_top">
          <span>软件专利展示</span>
          <img src="@/assets/nav.png" alt="">
        </div>
        <div class="show_imgs">
          <img src="@/assets/show.png" alt="">
        </div>
      </div>
    </div>
    <div class="feedback">
      <div class="w120">
        <div class="core_top">
          <span>软件专利展示</span>
          <img src="@/assets/nav.png" alt="">
          <p>欢迎留言，期待您宝贵的建议！</p>
        </div>
        <div class="selects">
          <div :class="index=='1'?'activeSel':''" @click="ClickSe('1')">
            <p>产品建议</p>
            <span>请输入您对某产品某功能在何场景下的改进建议或体验类问题。</span>
            <img v-if="index=='1'" src="@/assets/select.png" alt="">
          </div>
          <div :class="index=='2'?'activeSel':''" @click="ClickSe('2')">
            <p>产品建议</p>
            <img  v-if="index=='2'" src="@/assets/select.png" alt="">
            <span>请输入您对某产品某功能在何场景下的改进建议或体验类问题。</span>
          </div>
          <div :class="index=='3'?'activeSel':''" @click="ClickSe('3')">
            <img  v-if="index=='3'" src="@/assets/select.png" alt="">
            <p>产品建议</p>
            <span>请输入您对某产品某功能在何场景下的改进建议或体验类问题。</span>
          </div>
        </div>
        <div class="input_back">
          <span>建议内容：</span>
          <textarea v-model="description" name="" id="" ></textarea>
        </div>
        <div class="input_flex">
          <div class="flex_input">
            <span>您的名字：</span>
            <input type="text" v-model="name">
          </div>
          <div  class="flex_input">
            <span>您的联系方式：</span>
            <input type="text" v-model="tel">
          </div>
          <div class="flex_radio">
            <span>是否需要反馈：</span>
            <div>
              <div class="radio">
                <input id="radio-3" name="radio" type="radio" >
                <label for="radio-3" class="radio-label">是</label>
              </div>
              <div class="radio">
                <input id="radio-4" name="radio" type="radio" >
                <label for="radio-4" class="radio-label">否</label>
              </div>
            </div>
          </div>
        </div>
        <div class="input_btns">
          <div @click="sub">
            提交建议
          </div>
        </div>
      </div>
    </div>
    <div class="consulting">
      <div class="w120">
        <div >
          <div class="core_top">
            <span>售前咨询</span>
            <img src="@/assets/nav.png" alt="">
          </div>
          <div class="consulting_box">
            <div>
              <img src="@/assets/ones.png" alt="">
              <span>联系销售人员</span>
              <span>直接致电销售人员，立即进行购买咨询，早8:30-晚9:00</span>
              <span>+86 186 1179 3381</span>
            </div>
            <div>
              <img src="@/assets/twos.png" alt="">
              <span>联系智能框架师</span>
              <span>快速诊断，为您提供快速便捷的服务体验。</span>
              <span>+86 138 0125 4112</span>
            </div>
          </div>
        </div>
        <div>
          <div class="core_top">
            <span>技术支持</span>
            <img src="@/assets/nav.png" alt="">
          </div>
          <div class="consulting_box">
            <div>
              <img src="@/assets/ones.png" alt="">
              <span>联系销售人员</span>
              <span>直接致电销售人员，立即进行购买咨询，早8:30-晚9:00</span>
              <span>+86 130 2117 5339</span>
            </div>
            <div>
              <img src="@/assets/twos.png" alt="">
              <span>联系智能框架师</span>
              <span>快速诊断，为您提供快速便捷的服务体验。</span>
              <span>+86 186 1246 5112</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Divfooter />

  </div>
</template>
<script>
import qs from 'qs'
export default {
  data(){
    return{
      index:'1',
      value:'',
      name:'',
      tel:'',
      description:''
    }
  },
  methods:{
    ClickSe(e){
      if(this.index==e){
        return false
      }
      this.index = e
    },
    sub(){
            if(this.name==''){
                this.$message.error('请输入姓名')
                return false
            }
            if(this.tel==''){
                this.$message.error('请输入手机号')
                return false
            }else{
                let reg = /^[1][3,4,5,7,8][0-9]{9}$/
                if (!reg.test(this.tel)) {
                    this.$message.error("手机号码格式不正确")
                    return false
                }
            }
            let data = {
                name:this.name,
                tel:this.tel,
                description:this.description
            }
            this.MethodPost('http://api.softykt.net/Leaveword/SetLeaveWord',qs.stringify(data)).then(res=>{
                console.log(res)
                if(res.data.recode=='666'){
                    this.$message.success('提交成功')
                }
            })
        }
  }
}
</script>
<style lang="less" scoped>
.about{
  width: 100%;
  .top_back{
    width: 100%;
    height: 42.8rem;
    background: url(../../assets/mask.png) no-repeat;
    background-size: 100% 100%;
    position: relative;
  }
  .bjs{
    width: 50%;
    height: 42.8rem;
    background: url(../../assets/rightBj.png) no-repeat;
    background-size: 100% 100%;
    position: absolute;
    right: 0;
    top: 0;
  }
  .bj_box{
    padding: 19.3rem 0 0 0;
    box-sizing: border-box;
    >span{
      color: #fff;
      font-size: 4.6rem;
      &:nth-child(2){
        display: block;
        margin-top: 1.6rem;
        font-size: 1.6rem;
      }
    }
  }
  .about_content{
    width: 100%;
    padding: 9.4rem 0 10rem 0;
    box-sizing: border-box;
    background: #FFFFFF;
    .core_top{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        span{
          font-size: 3.6rem;
          color: #333B47;
        }
        img{
          width: 3.27rem;
          height: 1.169rem;
          margin-top: .7rem;
        }
    }
    .cont_imgs{
      width: 100rem;
      height: 49.2rem;
      margin: 6rem auto 6rem auto;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .content_txt{
      width: 100%;
      padding: 4rem;
      box-sizing: border-box;
      background: #F6F9FC;
      border-radius: 0.6rem;
      p{
        color: #000000;
        font-size: 2.4rem;
      }

      span{
        display: block;
        color: #000000;
        font-size: 1.6rem;
        text-indent:2em;
        margin-top: 2rem;
      }
    }
  }
  .about_show{
    background: url(../../assets/mask.png) no-repeat;
    width: 100%;
    padding: 10rem 0;
    background-size: 100% 100%;
    .core_top{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        span{
          font-size: 3.6rem;
          color: #FFFFFF;
        }
        img{
          width: 3.27rem;
          height: 1.169rem;
          margin-top: .7rem;
        }
    }
    .show_imgs{
      margin-top: 8rem;
      img{
        width: 100%;
        height: 35.6rem;
      }
    }
  }
  .feedback{
    width: 100%;
    padding: 10rem 0;
    box-sizing: border-box;
    background: #060B28;
    .core_top{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      span{
        font-size: 3.6rem;
        color: #FFFFFF;
      }
      img{
        width: 3.27rem;
        height: 1.169rem;
        margin-top: .7rem;
      }
      p{
        color: #FFFFFF;
        font-size: 2rem;
        margin-top: 2rem !important; 
      }
    }
    .selects{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 6rem;
      >div{
        cursor: pointer;
        width: 39rem;
        height: 15.7rem;
        background: rgba(205,224,238,0.1);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 4rem;
        box-sizing: border-box;
        p{
          color: #fff;
          font-size: 2rem;
        }
        span{
          color: #fff;
          font-size: 1.6rem;
          display: block;
          margin-top: 1.5rem;
        }
      }
      .activeSel{
        background: rgba(255,189,0,0.1);
        border: 1px solid #FFBD00;
        position: relative;
        img{
          width: 4.3rem;
          height: 4.3rem;
          position: absolute;
          right: 0;
          top: 0;
        }
      }
    }
    .input_back{
      margin-top: 4rem;
      display: flex;
      span{
        color: #FFFFFF;
        font-size: 1.6rem;
      }
      textarea{
        width: 111.1rem;
        height: 12rem;
        background: rgba(205,224,238,0.1);
        border: 1px solid #CDE0EE;
        padding: 1rem 2rem;
        box-sizing: border-box;
        color: #fff;
        font-size: 1.6rem;
        resize: none;
        outline: none;
      }
    }
    .input_flex{
      display: flex;
      align-items: center;
      margin-top: 3.4rem;
      .flex_input{
        display: flex;
        align-items: center;
        &:nth-child(2){
          margin-left: 4.2rem;
        }
        >span{
          color: #fff;
          font-size: 1.6rem;
        }
        input{
          width: 30rem;
          height: 4rem;
          border: 1px solid #FFFFFF;
          background: rgba(205,224,238,0.1);
          color: #fff;
          padding: 2rem;
          box-sizing: border-box;
          font-size: 1.6rem;
        }
      }
      .flex_radio{
        display: flex;
        align-items: center;
        margin-left: 3.9rem;
        span{
          color: #fff;
          font-size: 1.6rem;
        }
        >div{
          display: flex;
          align-items: center;
          .radio{
            display: flex;
            align-items: center;
            margin-right: 1rem;
            label{
              margin-left: 0.4rem;
              color: #fff;
              font-size: 1.6rem;
            }
            input{
              width: 1.5rem;
              height: 1.5rem;
            }
          }
         
        }
      }
    }
    .input_btns{
      margin-top: 6rem;
      display: flex;
      justify-content: center;
      align-items: center;
      >div{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 23.9rem;
        height: 5.1rem;
        background: #246DEB;
        color: #fff;
        font-size: 1.6rem;
        border-radius: 0.6rem;
        cursor: pointer;
      }
    }
  }
  .consulting{
    width: 100%;
    background: #fff;
    padding: 10rem 0;
    box-sizing: border-box;
    >div{
      >div{
      margin-top: 5rem;
      &:nth-child(1){
        margin-top: 0;
      }
      .core_top{
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          span{
            font-size: 3.6rem;
            color: #333B47;
          }
          img{
            width: 3.27rem;
            height: 1.169rem;
            margin-top: .7rem;
          }
      }
      .consulting_box{
        display: flex;
        justify-content: space-around;
        margin-top: 5rem;
      
        >div{
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          img{
            width: 12rem;
            height: 9.1rem;
          }
          span{
            color: #333333;
            font-size: 1.6rem;
            &:nth-child(2){
              font-size: 2rem;
              display: block;
              margin-top: 3.8rem;
            }
            &:nth-child(3){
              display: block;
              margin-top: 1.4rem;
            }
            &:nth-child(4){
              color: #246DEB;
              display: block;
              margin-top: 2.9rem;
            }
          }
        }
      }
    }
    }
  }
}
</style>